
import { DATE_TIME } from '@/utils/constants'
import { format } from 'date-fns'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  name: 'DateTimeDisplay',
})
export default class DateTimeDisplay extends Vue {
  @Prop({ required: true }) currentTime!: Date

  get displayDate() {
    return format(new Date(), DATE_TIME.DISPLAY_FORMAT)
  }

  get displayTime() {
    return format(this.currentTime, DATE_TIME.TIME_WITH_SECOND_FORMAT)
  }
}
